import { createFileRoute } from '@tanstack/react-router';

import { CopyProposalReviewPage } from '../features/presentations/copy-proposal-review-page';

export const Route = createFileRoute(
  '/manage/$companySlug/presentation-copy-proposals/$proposalId',
)({ component: RouteComponent });

function RouteComponent() {
  const { companySlug, proposalId } = Route.useParams();
  return <CopyProposalReviewPage companySlug={companySlug} proposalId={proposalId} />;
}
